import { Box, Container } from "@mui/material";
import CardServices from '../cardServices';
import { useEffect, useState } from "react";
import api from '../../../services/api';
import RegisterAccess from '../../../utils/registerAccess';
// import { useSelector } from 'react-redux';


interface MenuState {
  analise: number;
  analisado: number;
}

type MenuProps = {
  styles: string
}

export default function MenuFarmacovigilancia({ styles }: MenuProps) {

  // const user = useSelector(state => state.account.user);
  const [loadMenu, setLoadMenu] = useState<boolean>(true)
  const [menu, setMenu] = useState<MenuState>({
    analise: 0,
    analisado: 0,
  })

  useEffect(() => {
    api.get(`/menu/farmacovigilancia`)
      .then(response => {
        setMenu(response.data);
      }).catch(error => {

      }).finally(() => setLoadMenu(false))

  }, [])

  return (
    <Container>
      <RegisterAccess page={'farmacovigilancia'} />

      <Box className={styles}>
        <CardServices funcao='Técnico' load={loadMenu} count={menu.analise} icone={'/icones/expediente/entrada.svg'} nomeService={'Em Análise'} link={'/admin/farmacovigilancia/notificacoes/Pendente'} />
        <CardServices load={loadMenu} count={menu.analisado} icone={'/icones/expediente/saida.svg'} nomeService={'Analisados'} link={'/admin/farmacovigilancia/notificacoes/Analisado'} />
      </Box>

    </Container>
  )
}

